import { css } from '@emotion/css'
import { fontSize, spacing, fontFamily, colors } from '@offerzen/pinata-shame'

const styles = {
  notVisibleText: css({
    color: colors.froly,
    padding: spacing.extraSmall,
  }),

  visibleText: css({
    color: colors.cornflowerBlue,
    padding: spacing.extraSmall,
  }),

  badgeButton: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    marginLeft: spacing.small,
    marginRight: spacing.default,
    height: 24,
    width: 24,
    backgroundColor: colors.blueZodiac,
    borderColor: colors.blueZodiac,
    outline: 'transparent',

    svg: {
      minWidth: fontSize.medium,
    },

    '&:hover': {
      cursor: 'pointer',
    },
  }),

  badgeClose: css({
    background: 'transparent',
    outline: 'transparent',
    border: 'none',
    padding: 0,

    '&:hover': {
      cursor: 'pointer',
    },
  }),

  paragraph: css({
    marginTop: 0,
  }),

  container: css({
    width: '100%',
    backgroundColor: colors.blueZodiac,
    color: colors.white,
    padding: spacing.default,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    marginTop: 60,
    position: 'absolute',
    left: 0,
    top: 0,
  }),

  visibility: css({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: spacing.small,
  }),
}

export default styles
